import { useParams } from 'react-router-dom';

import { StudioItemDetailContainer } from '../components/StudioItemDetail/StudioItemDetailContainer';

export const StudioItemDetailPage = () => {
  const { studio_item_alias } = useParams();
  if (!studio_item_alias) throw new Error('studio_item_alias is required');

  return <StudioItemDetailContainer alias={studio_item_alias} />;
};
